<template>
  <div class="main-footer">
    <app-download v-if="isShowAppAndShare" />

    <div class="bg-footer">
      <template v-if="isShowAppAndShare">
        <sns-share class="sns-share">
          <img class="text"
            :src="textShareImage"
            :alt="$t('footer.heading.share')"
          />
        </sns-share>
        <trademark />
      </template>
      <div class="bottom-box">
        <div class="link-about-wrapper">
          <a
            v-if="isShowAboutLink"
            v-html="$t('footer.btn.agreement')"
            class="link-about"
            @click.prevent="showAbout"
          />
        </div>
        <p class="copyright" v-html="$t('copyright')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import localeCommon from '@locales/common'
import { languages, getLocaleKey } from '@constants'

import SnsShare from '@components/global/sns-share.vue'
import AppDownload from '@components/global/app-download.vue'
import Trademark from '@components/global/trademark.vue'

export default {
  name: 'mainFooter',
  $messages: localeCommon,
  components: {
    SnsShare,
    AppDownload,
    Trademark
  },
  computed: {
    lang() {
      let lang
      if (languages.enums.find(l => l.value === this.$route.params.lang)){
        lang = this.$route.params.lang
      } else {
        lang = languages.get(getLocaleKey()).value
      }
      return lang
    },
    isShowAppAndShare() {
      const excludeList = ['series', 'random', 'results', 'mypage', 'error']
      return excludeList.every((item) => {
        return !this.$route.path.includes(item)
      })
    },
    isShowAboutLink() {
      const excludeList = ['series', 'random', 'mypage']
      return excludeList.every((item) => {
        return !this.$route.path.includes(item)
      })
    },
    textShareImage() {
      return  require(`@images/sns-share/${this.lang}/text_share.png`)
    }
  },
  methods: {
    ...mapActions('terms', ['showTerms']),
    showAbout() {
      this.showTerms()
    }
  }
}
</script>

<style lang="scss" scoped>
.main-footer {
  z-index: 1;
  position: relative;
  .bg-footer {
    background-color: rgba(0, 0, 0, .5);
  }
  .sns-share {
    margin-top: 20px;
  }
  .bottom-box {
    background-image: url(#{$img-path}the-footer/bg_top.png), url(#{$img-path}the-footer/bg_bottom.png);
    background-repeat: no-repeat;
    background-position: 50% 0, 50% 100%;
    background-size: 100% auto, 100% auto;
    background-color: #0d151a;
    padding: 20px 0 25px;
    .copyright {
      text-align: center;
      font-size: $fs-middle;
      text-shadow: $ts-base;
    }
    .link-about-wrapper {
      text-align: center;
      .link-about {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 5px auto 20px;
        cursor: pointer;
        &::before {
          content: "";
          display: inline-block;
          width: 40px;
          height: 28px;
          background-image: url(#{$img-path}the-footer/icon_arrow.png);
          background-size: contain;
          margin-right: 8px;
          transform: translateY(3px);
        }
      }
    }
  }
}
</style>
